import React, { Component } from "react";
import Moment from "moment";
import moment from "moment";

import GlobalHelper from '../../../../Common/Helpers/GlobalHelper';

let DateTimeField = require("react-bootstrap-datetimepicker");
require("moment/locale/es-mx");

class SelectorFecha extends Component {
  constructor(props) {
    super(props);
  }

  changeDate(date) {
    if(this.props.funcionSeleccion)
      this.props.funcionSeleccion(this.props.nombreInput,date);
  }

  render() {
    let fecha =

      typeof this.props.fecha == "string"
        ? this.props.fecha.substr(0, 10)
        : this.props.fecha;

    if(fecha.includes("-")){

      var array = fecha.split("-");
      if(array[0].length == 4){
        array = array.reverse();
      }
      array = array.join("/")

      fecha = array;
    }


    let errorFormatoFecha =
      this.props && this.props.errorFormatoFecha ? " error-validacion" : "";

    let titulo = this.props.titulo /* ? this.props.titulo : "Fecha"; */
    let claseTitulo = this.props.classTitulo ? this.props.classTitulo : "";

    return (
      <div
        className={this.props.claseContainer ? this.props.claseContainer : ""}
      >
        {!this.props.noLabel && <div className={"labelComboProcesos " + claseTitulo}>{titulo}</div>}
        <div
          key={this.props.keyDate + "1"}
          className={
            !this.props.clasePicker
              ? "datePickerProcesos" + errorFormatoFecha
              : this.props.clasePicker + errorFormatoFecha
          }
        >
          <DateTimeField
            id={this.props.keyDate}
            key={this.props.keyDate}
            mode="date"
            dateTime={fecha}
            maxDate={this.props.maxToday ? Moment() : null}
            format={"DD/MM/YYYY"}
            inputFormat={"DD/MM/YYYY"}
            onChange={(e) => this.changeDate(e)}
            inputProps={this.props.inputProps}
          />
        </div>
      </div>
    );
  }
}

export default SelectorFecha;
